module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center big-padding"
  }, [_vm._v("\n    Souhaitez-vous "), _c('strong', [_vm._v("clôturer")]), _vm._v(" la tournée du\n    "), _c('strong', [_vm._v(_vm._s(_vm.tournee.cantonnierNom))]), _vm._v(" ?\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n      Clôturer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Annuler\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35884ef0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/tournees/TourneesClose.vue
// module id = 2097
// module chunks = 2